module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    class: {
      'flexContainer jc-fe': _vm.getMode === 'module'
    },
    attrs: {
      "id": "headerPlano"
    }
  }, [(_vm.getMode === 'module' && !_vm.isMobile) ? _c('button', {
    staticClass: "btnBase uppercase shades pointer",
    class: {
      active: _vm.canDisplayMenuShades
    },
    on: {
      "click": _vm.shades
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("planobuilder.shades")))])]) : _vm._e(), _vm._v(" "), (_vm.getMode === 'module' && _vm.lock === 'false' && !_vm.isMobile) ? _c('button', {
    staticClass: "btnBase uppercase ticketstrip pointer",
    class: {
      active: _vm.canDisplayMenuTicketStrip
    },
    on: {
      "click": _vm.ticketStrip
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("planobuilder.ticketStrip")))])]) : _vm._e(), _vm._v(" "), (_vm.getMode !== 'module' && _vm.lock === 'false' && !_vm.isMobile && !_vm.getPlanoDetails.archived && _vm.getPlanoDetails.status === 'IN PROGRESS') ? _c('button', {
    staticClass: "btnBase uppercase favorites fright pointer",
    class: {
      active: _vm.canDisplayMenuFavorite
    },
    on: {
      "click": _vm.favorites
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("planobuilder.favorite")))])]) : _vm._e(), _vm._v(" "), (_vm.getMode !== 'module' && _vm.lock === 'false' && !_vm.isMobile && !_vm.getPlanoDetails.archived && _vm.getPlanoDetails.status === 'IN PROGRESS') ? _c('button', {
    staticClass: "btnBase uppercase scratch fright pointer",
    class: {
      active: _vm.canDisplayMenuScratch
    },
    on: {
      "click": _vm.scratchPad
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("planobuilder.scratch")))])]) : _vm._e(), _vm._v(" "), (_vm.getMode !== 'module' && _vm.lock === 'false' && !_vm.isMobile && !_vm.getPlanoDetails.archived && _vm.getPlanoDetails.status === 'IN PROGRESS') ? _c('button', {
    staticClass: "btnBase uppercase library fright pointer",
    class: {
      active: _vm.canDisplayMenuLibrary
    },
    on: {
      "click": _vm.library
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("planobuilder.library")))])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-900f333e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/menu/MenuMainPlanoMassMarket.vue
// module id = 3314
// module chunks = 0